export default "__VITE_ASSET__CNDG59mE__"